import { render } from "./user.need.list.vue?vue&type=template&id=f3b30aac"
import script from "./user.need.list.vue?vue&type=script&lang=js"
export * from "./user.need.list.vue?vue&type=script&lang=js"

import exportComponent from "/drone/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__